import './style.css'
import Form from "@/components/Form";

export default class NewsletterForm {
    static selector = '.newsletter-form'

    constructor(block) {
        this.block = block

        this.formElement = this.block.querySelector(".form");

        this.form = new Form(this.formElement, {
            onSubmitSucceeded: this.handleSubmitSucceeded,
            submitLoadingLabel: 'Subscribing...',
            submitSuccessLabel: 'Subscribed',
            resetAfterSubmit: false,
            gainControlOnSubmitSucceeded: false,
        })
    }

    handleSubmitSucceeded = (response) => {
        console.log('Success!', response);
    };
}
